import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=aaca0d7c&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=aaca0d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaca0d7c",
  null
  
)

export default component.exports